import { MouseEvent, } from "react";
import { generatePath, Link, } from "react-router-dom";
import { Box, Flex, Stack, Text, } from "@chakra-ui/react";

import { IOperation, } from "../../../api";
import { formatDate, } from "../../../utils";
import { RoutesMap, } from "../../../routes.tsx";
import { Operation, } from "../MainPage/Operations/Operation.tsx";
import { formatTermUnit, } from "../../../utils/formatTermUnit.ts";
import { useOperationListFilters, } from "../../../store/operationListFilters.ts";
import { OperationsEmptyBlock, } from "../MainPage/Operations/OperationsEmptyBlock.tsx";

export interface IOperationsListView {
  isLoading: boolean;
  isSuccess: boolean;
  data: IOperation[] | undefined;
  emptyBlockVariant?: "default" | "tiny";
  cursorType?: "default" | "pointer";
}

export function OperationsListView(Props: IOperationsListView,) {
  const {
    isLoading,
    isSuccess,
    data,
    emptyBlockVariant = "default",
    cursorType = "pointer",
  } = Props;

  // that will trigger rerendering of the component when the state changes
  // we don't need to use the state itself, so we can just call the hook
  useOperationListFilters(state => state.state,);
  // this how we will get our filter flags
  const getFilterFlags = useOperationListFilters(state => state.getStateFlags,);

  const filteredOperations = data
    ?.filter(operation => getFilterFlags().includes(operation.operationStatus,),)
    .sort(a => a.operationStatus === 3 ? -1 : 1,)
    ?? [];

  const onOperationClick = (event: MouseEvent<HTMLAnchorElement>,) => {
    if (cursorType === "default") {
      event.preventDefault();
      return;
    }
  };

  return (
    <Stack spacing={2}>
      {isLoading && new Array(3,).fill(0,).map((_, i,) => (
        <Operation key={i} isLoading />
      ),)}

      {isSuccess && filteredOperations.length > 0 && filteredOperations
        .map(operation => (
          <Link
            key={operation.id}
            to={generatePath(RoutesMap.operations.operation, { id: operation.id.toString(), },)}
            onClick={onOperationClick}
          >
            <Operation
              logoSrc={operation.smallIconLink}
              paymentDate={formatDate(new Date(operation.dateNextPayment,),)}
              termDate={operation.termInfo.value + " " + formatTermUnit(operation.termInfo.unit, operation.termInfo.value,)}
              amount={operation.amount / 100}
              companyName={operation.merchantName}
              cursorType={cursorType}
            />
          </Link>
        ),)}

      {isSuccess && filteredOperations.length === 0 && (
        <Box>
          {emptyBlockVariant === "default" && <OperationsEmptyBlock />}
          {emptyBlockVariant === "tiny" && (
            <Flex direction="column" alignItems="center" py={20}>
              <Text>Нет оплаченных покупок</Text>
            </Flex>
          )}
        </Box>
      )}
    </Stack>
  );
}
